import styled from 'styled-components';

export const SurveyCard = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1300;
  width: 360px;
  max-width: calc(100vw - 48px);
  padding: 20px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows.paper};
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Title = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const ScoreRow = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
`;

export const ScoreButton = styled.button<{ $selected: boolean }>`
  flex: 1;
  min-width: 0;
  padding: 0;
  height: 28px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  border: 1px solid
    ${({ theme, $selected }) => ($selected ? theme.palette.primary.main : theme.ui.border.main)};
  background: ${({ theme, $selected }) => ($selected ? theme.palette.primary.main : theme.palette.background.paper)};
  color: ${({ theme, $selected }) => ($selected ? theme.palette.common.white : theme.palette.text.primary)};

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary.main};
    background: ${({ theme, $selected }) => ($selected ? theme.palette.primary.main : theme.tint.primary.subtle)};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.main};
    outline-offset: 2px;
  }
`;

export const ScoreLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  span {
    font-size: 12px;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export const CommentLabel = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const Confirmation = styled.div`
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  background: ${({ theme }) => theme.toast.success.background};
  color: ${({ theme }) => theme.toast.success.text};
`;
